import React from "react";
import style from "../../Styles/Components/HistoryCard.module.css";

const HistoryCard = ({ marginTop = null, type, title, date, eventPrize, companyLogoUrl, handleModal, ELocale }) => (
  <div style={{ marginTop: marginTop ? 8 : 0 }} className={style.container} onClick={() => handleModal()}>
    <div className={style.contentContainer}>
      <div className={style.timeContainer}>
        <img className={style.clockIcon} src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-time-dark.svg"} alt="clockIcon" />
        <span className={style.time}>{date}</span>
      </div>
      <span
        style={{
          marginTop: type === "auth" ? 6 : 10,
          fontSize: type === "auty" ? 16 : 14
        }}
      >
        {title}
      </span>
    </div>
    <div className={style.statusContainer}>
      {type === "auth" && <span className={style.authStatus}>
        {ELocale === 'kr' ? '인증완료' : null}
        {ELocale === 'en' ? 'Authenticated' : null}
        {ELocale === 'cn' ? '验证成功' : null}
      </span>}
      {type === "event" && (
        <div className={style.barcodeContainer}>
            { eventPrize.barcodeUrl ?
                <div className={style.barcode} style={{backgroundImage: "url('" + eventPrize.barcodeUrl + "')"}} />
                :
                <div>{eventPrize.promotionCode}</div>
            }
          <span className={style.showDetail}>
            {ELocale === 'kr' ? '자세히 보기' : null}
            {ELocale === 'en' ? 'Details' : null}
            {ELocale === 'cn' ? '查看详情' : null}
          </span>
        </div>
      )}
    </div>
  </div>
);

export default HistoryCard;
